{
  "states": {
    "loading": "Memuat...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Cerah",
    "Clouds": "Berawan",
    "Rain": "Hujan",
    "Drizzle": "Gerimis",
    "Thunderstorm": "Badai petir",
    "Snow": "Salju",
    "Mist": "Kabut tipis",
    "Smoke": "Asap",
    "Haze": "Kabut asap",
    "Dust": "Debu",
    "Fog": "Kabut",
    "Sand": "Pasir",
    "Ash": "Abu",
    "Squall": "Angin kencang",
    "Tornado": "Tornado"
  },
  "modal": {
    "defaultTitle": "Cuaca",
    "subtitle": "Kondisi saat ini",
    "showFahrenheit_aria": "Tampilkan Fahrenheit",
    "showCelsius_aria": "Tampilkan Celsius",
    "switchToCelsius_title": "Beralih ke °C",
    "switchToFahrenheit_title": "Beralih ke °F",
    "feelsLike": "Terasa seperti {{temp}}°{{unit}}",
    "humidityWind": "Kelembapan {{humidity}}% · Angin {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Sekarang",
    "hourlyOffset": "{{hours}}j",
    "hourlyStrip_aria": "Suhu per jam",
    "hourlyLocked": "Prakiraan per jam adalah fitur Pro.",
    "statsLocked": "Detail cuaca adalah fitur Pro.",
    "stats": {
      "sunrise": "Matahari terbit",
      "sunset": "Matahari terbenam",
      "feels": "Terasa",
      "humidity": "Kelembapan",
      "wind": "Angin",
      "rain": "Hujan"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Prakiraan 5 Hari",
    "forecastLoading": "Memuat prakiraan…",
    "forecastUnavailable": "Prakiraan tidak tersedia",
    "forecastLocked": "Prakiraan 5 hari adalah fitur Pro.",
    "forecastRow_aria": "Prakiraan lima hari",
    "proHeadline": "Prakiraan lengkap adalah bagian dari Pro.",
    "proFeatures": "Per jam · Kondisi terperinci · Prospek 5 hari."
  }
}
